export default "__VITE_ASSET__E7D$HWlb__"